// extracted by mini-css-extract-plugin
export default {"container":"Main_container__Zd8GB","content":"Main_content__2EtVA"};